module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "tabs",
    style: ({
      width: _vm.headerWidth
    })
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab,
      staticClass: "description_tab tab pointer ma0",
      class: {
        active: _vm.activeTab === tab,
      },
      style: ({
        width: 100 / _vm.tabs.length + '%'
      }),
      on: {
        "click": function($event) {
          return _vm.switchTab(tab)
        }
      }
    }, [_c('pl-button', {
      staticClass: "tab-btn",
      class: {
        'btn-active': _vm.activeTab === tab,
      }
    }, [_vm._t(_vm.tabHeadSlotName(tab), function() {
      return [_vm._v(_vm._s(tab) + " ")]
    })], 2)], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "slider",
    style: ({
      left: _vm.sliderPosition,
      width: 100 / _vm.tabs.length + '%'
    }),
    attrs: {
      "role": "presentation"
    }
  })], 2)]), _vm._v(" "), _c('main', {
    staticClass: "card-body",
    style: ({
      minHeight: _vm.minHeight
    })
  }, [_c('div', {
    staticClass: "tab-panel"
  }, [_vm._t(_vm.tabPanelSlotName)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-bda24ebe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plTabs/plTabs.vue
// module id = 2383
// module chunks = 61